import { useParams } from 'react-router-dom';

import { Popconfirm, Typography, message } from 'antd';

import { useAppSelector } from '@/hooks/redux';
import { IComment } from '@/interfaces/comments';
import { useDeleteCommentMutation } from '@/services/comments';
import { StyledProp } from '@/styled';

const Delete = (props: IComment & StyledProp & { isReply: boolean }) => {
  const { id } = useParams();

  const [deleteComment, deletedComment] = useDeleteCommentMutation();
  const user = useAppSelector(({ auth }) => auth.user);
  const deleteAnswer = async () => {
    deleteComment({ lessonId: id, commentId: props.id, isReply: props.isReply })
      .then(() => {
        message.success('Comentário excluído com sucesso');
      })
      .catch(() => {
        message.error('Erro ao excluir o comentário');
      });
  };

  if (props?.user?.id !== user?.id) {
    return;
  }

  return (
    <Popconfirm title='Realmente deseja deletar o comentário?' okText='Sim' cancelText='Não' onConfirm={deleteAnswer}>
      <Typography.Text underline disabled={deletedComment.isLoading}>
        Excluir
      </Typography.Text>
    </Popconfirm>
  );
};

export default Delete;
